module.exports = __webpack_public_path__ + "img/1440.2b6202fd.jpg";